export default "__VITE_ASSET__C87_$E_3__"